/* Materia Themes — Cart-drawer safety net.
   ────────────────────────────────────────────────────────────────────────────
   Document-level capture-phase listener for trash-icon clicks in the
   cart drawer. The original <mini-cart-remove-button> custom element
   handler still exists as a feature target — but a single broken
   render or a JS error there has historically left the drawer stuck,
   requiring a full page reload to recover. This file is the
   bulletproof backup that always runs and always wins.

   Why capture phase + stopImmediatePropagation?
   - Capture-phase listeners fire BEFORE the inner <a href> default
     action and BEFORE any bubble-phase listeners on the custom
     element. We call preventDefault to kill the link navigation, then
     stopImmediatePropagation when we own the delete so the custom-
     element handler can't double-fire and double-decrement the cart.

   Why we still defer to the custom element for wishlist-mode clicks:
   - When `show_message_when_remove` is enabled in settings, the trash
     button gets `.action-add-wishlist` and the first click shows a
     "remove and save to wishlist?" confirmation panel instead of
     deleting. If the product isn't yet in the wishlist we let the
     custom-element handler take over by NOT stopping propagation.
*/
"use-strict";

(function () {
  function findCartContainer() {
    return (
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer")
    );
  }
  function isInWishlist(productHandle) {
    try {
      const raw = localStorage.getItem("materia__wishlist-items");
      if (!raw) return false;
      const list = JSON.parse(raw);
      return Array.isArray(list) && list.indexOf(productHandle) !== -1;
    } catch (_) {
      // Corrupt storage — clear so the wishlist flow self-heals on the
      // next interaction.
      try { localStorage.removeItem("materia__wishlist-items"); } catch (_) {}
      return false;
    }
  }
  function fallbackDelete(lineKey) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .catch(() => null)
      .then(() => {
        try { window.location.reload(); } catch (_) {}
      });
  }
  /* Force-clear any sticky CSS state that would block clicks. The
     `cart-items.cart-refreshing` rule sets `pointer-events: none`, so
     if a prior interaction left this class on, the user can't click
     anything. Self-heal on every trash click. */
  function selfHeal() {
    document.querySelectorAll("cart-items.cart-refreshing")
      .forEach((el) => el.classList.remove("cart-refreshing"));
    document.querySelectorAll("mini-cart-remove-button.loading")
      .forEach((el) => el.classList.remove("loading"));
  }

  document.addEventListener(
    "click",
    function (event) {
      const target = event.target;
      if (!target || !target.closest) return;
      const trash = target.closest("mini-cart-remove-button");
      if (!trash) return;

      /* Always kill the link's default navigation so a misfire never
         dumps the shopper onto /cart. */
      event.preventDefault();

      /* Wishlist-confirmation mode: first click on a not-yet-wishlisted
         product should show the confirmation panel, not delete. Let
         the custom-element handler take over by returning WITHOUT
         calling stopImmediatePropagation. */
      const wishlistMode = trash.classList.contains("action-add-wishlist");
      if (wishlistMode && !isInWishlist(trash.dataset.productHandle)) {
        return;
      }

      /* This is a real delete. Take over: stop the custom-element
         handler from also firing so we don't double-decrement. */
      event.stopImmediatePropagation();

      const lineKey = trash.dataset.index;
      if (!lineKey) {
        console.warn("[cart] trash button missing data-index", trash);
        return;
      }

      selfHeal();

      const cartEl = findCartContainer();
      if (cartEl && typeof cartEl.updateQuantity === "function") {
        try {
          cartEl.updateQuantity(lineKey, 0);
          return;
        } catch (err) {
          console.warn(
            "[cart] updateQuantity threw — falling back to direct delete",
            err
          );
        }
      }

      /* Last-resort fallback: post directly to /cart/change.js and
         reload. Guarantees the line is removed even if every other
         path is broken. */
      fallbackDelete(lineKey);
    },
    true /* capture phase */
  );
})();

/* Martéa — Regalo automático v3: pendientes Leticia con la compra de una chaqueta o blazer.
   Si el carrito tiene una chaqueta/blazer, añade los pendientes (1 ud.); si ya no la tiene, los quita.
   El precio 0 € lo aplica el descuento automático "Regalo pendientes Leticia" en el checkout.
   Diagnóstico: abrir cualquier página con ?regalo_debug=1 muestra un cuadro negro con el estado. */
(function () {
  var GIFT_VARIANT = 54780937765205;
  var RULE = /chaqueta|blazer/i;
  var CART_URL = /\/cart\/(add|change|update|clear)/;
  var busy = false;
  var again = false;
  var nativeFetch = window.fetch;
  var DEBUG = false;
  try {
    if (/[?&]regalo_debug=1/.test(location.search)) sessionStorage.setItem("regalo_debug", "1");
    if (/[?&]regalo_debug=0/.test(location.search)) sessionStorage.removeItem("regalo_debug");
    DEBUG = sessionStorage.getItem("regalo_debug") === "1";
  } catch (e) {}

  function dbg(text) {
    if (!DEBUG) return;
    try {
      var box = document.getElementById("regalo-debug");
      if (!box) {
        box = document.createElement("div");
        box.id = "regalo-debug";
        box.style.cssText = "position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;max-height:40vh;overflow:auto;background:#000;color:#0f0;font:12px/1.4 monospace;padding:8px;border-radius:6px;white-space:pre-wrap;";
        (document.body || document.documentElement).appendChild(box);
      }
      box.textContent += text + "\n";
    } catch (e) {}
  }
  function log() {
    var parts = [].slice.call(arguments).map(function (x) { return typeof x === "string" ? x : JSON.stringify(x); });
    try { console.log("[regalo]", parts.join(" ")); } catch (e) {}
    dbg(parts.join(" "));
  }
  function json(url, opts) {
    return nativeFetch(url, opts).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, status: r.status, data: j }; });
    });
  }
  function post(url, body) {
    return json(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    });
  }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  function refreshUI() {
    if (onCartPage()) { location.reload(); return; }
    var el = document.querySelector("cart-drawer, cart-notification");
    try {
      if (el && typeof el.getSectionsToRender === "function" && typeof el.renderContents === "function") {
        var ids = el.getSectionsToRender().map(function (s) { return s.id; });
        nativeFetch(location.pathname + "?sections=" + ids.join(","), { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (sections) { el.renderContents({ sections: sections }); })
          .catch(function () {});
      }
    } catch (e) {}
  }

  function sync(origin) {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return json("/cart.js").then(function (res) {
      var items = (res.data && res.data.items) || [];
      var gift = null, hasQualifying = false;
      items.forEach(function (it) {
        if (it.variant_id === GIFT_VARIANT && it.properties && it.properties._regalo) gift = it;
        else if (it.variant_id !== GIFT_VARIANT && RULE.test(it.product_title || "")) hasQualifying = true;
      });
      log("[" + (origin || "sync") + "] líneas:", items.map(function (i) { return i.product_title; }), "| chaqueta/blazer:", hasQualifying, "| regalo ya en carrito:", !!gift);
      if (hasQualifying && !gift) {
        return post("/cart/add.js", { id: GIFT_VARIANT, quantity: 1, properties: { _regalo: "pendientes-leticia" } }).then(function (r) {
          log("añadir regalo:", r.ok ? "OK" : "ERROR " + r.status, r.ok ? "" : JSON.stringify(r.data));
          if (r.ok) refreshUI();
        });
      }
      if (!hasQualifying && gift) {
        return post("/cart/change.js", { id: gift.key, quantity: 0 }).then(function (r) { log("quitar regalo:", r.ok ? "OK" : "ERROR"); if (r.ok) refreshUI(); });
      }
      if (gift && gift.quantity > 1) {
        return post("/cart/change.js", { id: gift.key, quantity: 1 }).then(function (r) { if (r.ok) refreshUI(); });
      }
    }).catch(function (e) { log("error:", String(e)); }).then(function () {
      busy = false;
      if (again) { again = false; setTimeout(sync, 100); }
    });
  }

  function scheduleSync() {
    [600, 1500, 3000].forEach(function (ms) { setTimeout(function () { sync("clic"); }, ms); });
  }

  /* fetch */
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = nativeFetch.apply(this, arguments);
    if (CART_URL.test(url)) p.then(function () { setTimeout(function () { sync("fetch"); }, 200); }).catch(function () {});
    return p;
  };
  /* XMLHttpRequest */
  try {
    var xhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (CART_URL.test(String(url))) this.addEventListener("loadend", function () { setTimeout(function () { sync("xhr"); }, 200); });
      } catch (e) {}
      return xhrOpen.apply(this, arguments);
    };
  } catch (e) {}
  /* Cualquier clic o envío de formulario puede ser un "añadir al carrito" */
  document.addEventListener("click", scheduleSync, true);
  document.addEventListener("submit", scheduleSync, true);
  window.addEventListener("pageshow", function () { sync("pageshow"); });

  log("script regalo v3 activo en", location.pathname);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { sync("carga"); });
  else sync("carga");
})();
